export default function ValuePropositions() {
  return (
    <section className="py-20 bg-white">
      <div className="container-wide">
        <h2 className="text-center mb-16">
          Dance studio directors and owners love this program because
        </h2>

        {/* Subsection A: text left, image right (matching WordPress) */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="mb-4">It gives students a backstage pass</h3>
            <p className="text-warm-600">
              to Broadway&rsquo;s hottest shows through master classes with cast
              members from Broadway national tours and touring dance companies.
              Students learn choreography in the style of the selected show and
              participate in a Q&amp;A with the cast member in these 1.5 hour
              master classes.
            </p>
          </div>
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-accent-100 to-accent-50 rounded-3xl opacity-40 -z-10 hidden md:block" />
            <img
              src="/images/value-props/workshop.jpg"
              alt="Dance workshop in action"
              className="rounded-2xl shadow-lg"
            />
          </div>
        </div>

        {/* Subsection B: image left, text right */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-accent-100 to-accent-50 rounded-3xl opacity-40 -z-10 hidden md:block" />
            <img
              src="/images/value-props/students.jpg"
              alt="Students in a masterclass"
              className="rounded-2xl shadow-lg"
            />
          </div>
          <div>
            <h3 className="mb-4">Your students will have</h3>
            <p className="text-warm-600">
              The opportunity to work with the industry&rsquo;s best teachers as
              they tour through your area without the added cost of flying in
              faculty members. This is a truly unique way for students to
              experience the dance styles used in some of today&rsquo;s top shows.
            </p>
          </div>
        </div>

        {/* Subsection C: full-width centered layout (matching WordPress) */}
        <div className="text-center">
          <h2 className="mb-2">We also Provide</h2>
          <p className="text-warm-600 max-w-3xl mx-auto mb-2">
            Marketing Material to help generate buzz around your studio and
            boost registration for your master class.
          </p>
          <p className="text-warm-600 max-w-3xl mx-auto mb-8">
            An in-house group ticket agent to book discount tickets to see your
            faculty member perform in their national touring show.
          </p>
          <img
            src="/images/value-props/performance.jpg"
            alt="Group performance outdoors"
            className="w-full rounded-lg"
          />
        </div>
      </div>
    </section>
  );
}
